module.exports = __webpack_public_path__ + "soundfont/NewDrumSamples/MP3/Stacker-4fdf84345f462cc022c0b8725846fbd4.mp3";


//////////////////
// WEBPACK FOOTER
// ./soundfont/NewDrumSamples/MP3/Stacker.mp3
// module id = 23
// module chunks = 0